import { Drawer } from "antd";
import { Nav } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const MobileMenu = ({ visible, onClose, showLoginHandler, showRegisterHandler }) => {
  const history = useHistory();

  const onRouteHandler = (route) => {
    onClose();
    history.push(route);
  };

  return (
    <>
      <Drawer
        zIndex="1030"
        placement="right"
        visible={visible}
        onClose={onClose}
        closeIcon={<i className="far fa-times" />}
      >
        <Nav className="flex-column mobile-menu py-4 user-select-none">
          <Nav.Link onClick={showLoginHandler}>Masuk</Nav.Link>
          <Nav.Link onClick={showRegisterHandler}>Daftar</Nav.Link>
          <Nav.Link onClick={() => onRouteHandler("/")}>Home</Nav.Link>
          <Nav.Link onClick={() => onRouteHandler("/products")}>Katalog</Nav.Link>
          <Nav.Link onClick={() => onRouteHandler("/cart")}>Keranjang</Nav.Link>
          <Nav.Link onClick={() => onRouteHandler("/wishlist")}>Favorit</Nav.Link>
        </Nav>
      </Drawer>
    </>
  );
};

export default MobileMenu;
